import { Component, OnInit } from '@angular/core';
import { CourseHService } from '../courseH.service';
import { ConfirmationService } from 'primeng/primeng';
import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';



//import {MatDialog, MatDialogConfig} from "@angular/material"
@Component({
  selector: 'viewcourseH',
  templateUrl: 'viewcourseH.component.html',
  styleUrls: ['viewcourseH.component.scss']
})

export class ViewcourseHComponent implements OnInit {
  public schoolId: any;
  display = "none"
  public info:boolean=false;
  courses: any[] = [];
  public ShowCourseSecData: any = [];
  


  public coursename: string = '';
  public schoolid: string = '1';
  public selectedDepartment: string = '';
  public duration: string = '';
 
  
  constructor(private courseService: CourseHService,private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    
  }
  ngOnInit() {
   this.ShowCourse();
  }

  private ShowCourse() {
    this.courseService.getHigherEdChildCourseList()._finally(() => { }).subscribe(response => {
        console.log("ShowCourseSectionMapping",response);
        this.ShowCourseSecData = response['items'];
        this.courses = response['items'];
        console.log('courses', this.courses)
        console.log('ShowCourseSecData', this.ShowCourseSecData)
       
      }
    )
  }
  
  

  postcourseModeules() {
    var payload = {
      
       Course:  this.coursename,
       SchoolId: this.schoolid,
       DepartmentId: this.selectedDepartment,
       Duration: this.duration,
    };
    
    console.log("postcourseModeules",payload);
  
    this.courseService
    .postHigherHiEduCourse(payload)
    .finally(() => {})
    .subscribe(
      (response) => {
        this.messageService.add({
          severity: "success",
          summary: "Talkative Parents",
          detail: "Semester Batch Added Successfully",
        });
        this.display = "none";
        this.ShowCourse();
    
        console.log(response);
      },
      (error) => {}
    );
  }
  
  
  
  
   roleinfo(){
   this.info=true;
  }


addCourse() {
  this.display= "block"
 
}
onCloseHandled() {
  this.display= "none";
}




}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/viewcourse/viewcourseH.component.ts